import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from "@hassel-it/angular-common";
import {environment} from "../environments/environment";
import {TimeagoIntl} from "ngx-timeago";
import {strings as danishStrings} from 'ngx-timeago/language-strings/da';
import {Shipment} from "./services/shipment";
import {ShipmentRoute} from "./services/shipment-route";
import {ShipmentsService} from "./services/shipments.service";
import {Lightbox} from "ngx-lightbox";
import {DomSanitizer} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.css']
})
export class AppComponent  implements  OnInit{

    isNavbarCollapsed = true;

    public environment;

    @Input() public _shipment: Shipment;
    @Input() public shipmentRoutes: ShipmentRoute[];

    @Output() stuffChanged = new EventEmitter<any>();

    constructor(public authService: AuthService, intl: TimeagoIntl,        public activatedRoute: ActivatedRoute) {
        this.environment = environment;
        intl.strings = danishStrings;
        intl.changes.next();
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe((data) => {
        });
    }
}
